import React from "react";
import {ScrollChoreography} from "./components/ui/scroll-choreography";
import {photos} from "./FirstSFGData";

const {story} = photos

const FirstSFGPhotoStory = () => (
    <section className={'sfg-story'} aria-label={'In the field'}>
        <div className={'sfg-story-intro'}>
            <p className={'sfg-section-code'}>In the field</p>
            <h2>Every flyer, invitation and announcement starts with the people in these photos.</h2>
            <p className={'sfg-section-copy'}>Keep scrolling.</p>
        </div>
        <ScrollChoreography
            className={'sfg-story-choreo'}
            images={{
                topLeft: story.topLeft.src,
                topRight: story.topRight.src,
                bottomLeft: story.bottomLeft.src,
                bottomRight: story.bottomRight.src,
            }}
            alts={{
                topLeft: story.topLeft.alt,
                topRight: story.topRight.alt,
                bottomLeft: story.bottomLeft.alt,
                bottomRight: story.bottomRight.alt,
            }}
        >
            <div className={'sfg-story-caption'}>
                <p className={'sfg-story-motto'}>De Oppresso Liber</p>
                <p className={'sfg-story-translation'}>To free the oppressed</p>
            </div>
        </ScrollChoreography>
        <div className={'sfg-story-strip'}>
            {photos.strip.map(photo => (
                <figure key={photo.src}>
                    <img src={photo.src} alt={photo.alt} loading={'lazy'}/>
                </figure>
            ))}
        </div>
    </section>
)
export default FirstSFGPhotoStory
